const BASE_URL = `${process.env.REACT_APP_NOMMIA_API_URL}/client-api`;
// Note: For production, it's safer to move this key to a .env file (e.g., process.env.REACT_APP_NOMMIA_API_KEY)
const API_KEY = '65f84ac479c889266b545881cf8abd7c3e1ff7958c08789c8d08e749da034cc1';

const getHeaders = () => ({
    'x-client-api-key': API_KEY,
    'Content-Type': 'application/json'
});

/**
 * Fetch paginated list of users
 */
export const fetchClientsList = async (page = 1, limit = 500) => {
    try {
        const response = await fetch(`${BASE_URL}/users?page=${page}&limit=${limit}`, {
            method: 'GET',
            headers: getHeaders()
        });

        if (!response.ok) {
            const errData = await response.json();
            throw new Error(errData.errorMessage || `Error ${response.status}: Failed to fetch clients`);
        }

        const data = await response.json();
        return data;
        
    } catch (error) {
        console.error("Nommia API Error (fetchClientsList):", error);
        throw error;
    }
};

/**
 * Fetch full details for a specific user
 */
export const fetchClientDetails = async (userId) => {
    try {
        const response = await fetch(`${BASE_URL}/users/${userId}`, {
            method: 'GET',
            headers: getHeaders()
        });

        if (!response.ok) {
            const errData = await response.json();
            throw new Error(errData.errorMessage || `Error ${response.status}: Failed to fetch client details`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Nommia API Error (fetchClientDetails for ${userId}):`, error);
        throw error;
    }
};